function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.295 10.312h3.45V7.026a.653.653 0 00-.915-.598l-4.68 2.047v-1.45a.653.653 0 00-.914-.597l-3.333 1.458.674 6.292c.518-1.298 2.245-3.866 5.718-3.866zM10.37 5.837H2.441L.861 20.593a.653.653 0 00.65.723h9.79a.653.653 0 00.65-.723L10.37 5.837zM9.853 1.012a.653.653 0 00-.65-.584H3.61a.653.653 0 00-.65.584l-.377 3.52h7.649l-.378-3.52z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.491 11.618h-4.196a4.845 4.845 0 00-4.849 4.849v3.925l4.388-4.387a.653.653 0 11.923.923l-4.387 4.387h3.925a4.845 4.845 0 004.849-4.848V12.27a.653.653 0 00-.653-.653z",
  fill: "#fff"
});

function SvgIconGeneralInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconGeneralInfo;